/*
 * 通用消息提示：pc用的是message形式，m站用的是toast形式
 * */
const AcspMessage = {};

const defaultOptions = {
  type: "text", // 提示类型：text/success/notice
  message: "", // 提示文本
  duration: 2, // 默认自动关闭延时，单位秒
};

AcspMessage.show = function (options) {
  AcspMessage.configShow &&
    AcspMessage.configShow({ ...defaultOptions, ...options });
};

/**
 * 只展示文本
 */
AcspMessage.showText = function (message) {
  AcspMessage.show({ message, type: "text" });
};

/**
 * 成功提示
 */
AcspMessage.showSuccess = function (message) {
  AcspMessage.show({ message, type: "success" });
};

/**
 * 错误、警告提示
 */
AcspMessage.showNotice = function (message) {
  AcspMessage.show({ message, type: "notice" });
};

/**
 * 配置vant-ui的toast
 * @param toast
 */
AcspMessage.configVant = function (toast) {
  AcspMessage.configShow = function (options) {
    const {
      message, // 提示文本
      duration, // 默认自动关闭延时，单位秒
      type, // 提示类型：text/success/notice
    } = options || {};

    if (type === "success") {
      toast.success({ message, duration });
    } else if (type === "notice") {
      toast.fail({ message, duration });
    } else {
      toast({ message, duration });
    }
  };
};

/**
 * 配置ant-vue
 * @param Message
 */
AcspMessage.configAntVue = function (Message) {
  AcspMessage.configShow = function (options) {
    const {
      message, // 提示文本
      duration, // 默认自动关闭延时，单位秒
      type, // 提示类型：text/success/notice
    } = options || {};

    if (type === "success") {
      Message.success(message, duration);
    } else if (type === "notice") {
      Message.warn(message, duration);
    } else {
      Message.info(message, duration);
    }
  };
};

AcspMessage.configShow = function (options) {};

export default AcspMessage;
